import { Frown, Tv, ChefHat, AlertTriangle } from "lucide-react";

const items = [
  {
    icon: Frown,
    title: "Same five foods, every week",
    text: "Food boredom is real. Without variety, even adventurous kids retreat to their safety menu.",
  },
  {
    icon: AlertTriangle,
    title: "Mealtime resistance",
    text: "Negotiating, bargaining, bribing — and still ending dinner with crossed arms.",
  },
  {
    icon: ChefHat,
    title: "Cooking two dinners",
    text: "One for the grown-ups, one for the tiny food critic. Nobody has time for that.",
  },
  {
    icon: Tv,
    title: "Screens just to get through",
    text: "An easy fix that quietly replaces the conversation, the connection, the routine.",
  },
];

export default function Problem() {
  return (
    <section data-testid="section-problem" className="relative py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-extrabold uppercase tracking-widest text-pb-coral">We see you, parents</p>
          <h2 className="font-display font-black text-4xl md:text-5xl mt-3 leading-tight">
            Dinner shouldn’t feel like a <span className="wavy">daily standoff</span>.
          </h2>
          <p className="mt-5 text-lg text-pb-soft leading-relaxed">
            You’re not failing. The dinner table is genuinely hard for families with kids 2–7 — short attention spans, big opinions, and the same five foods on rotation. Plate Buddies takes the pressure off and turns mealtime into a routine your kids actually look forward to.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => (
            <div
              key={it.title}
              data-testid={`card-problem-${i}`}
              className="group bg-pb-cream rounded-3xl p-6 border border-pb-sky/40 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(28,22,40,0.08)] transition-all duration-300"
            >
              <div className="h-12 w-12 rounded-2xl bg-white flex items-center justify-center shadow-sm">
                <it.icon className="h-5 w-5 text-pb-coral" />
              </div>
              <h3 className="font-display font-black text-xl mt-5">{it.title}</h3>
              <p className="text-pb-soft mt-2 text-sm leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>

        {/* Founder credibility moment */}
        <div className="mt-14 rounded-3xl bg-pb-cream p-6 sm:p-8 border-2 border-white shadow-[0_18px_40px_rgba(28,22,40,0.06)] flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <div className="h-14 w-14 rounded-2xl bg-white flex items-center justify-center shadow-sm flex-shrink-0">
            <span className="font-display font-black text-pb-coral text-2xl">"</span>
          </div>
          <p data-testid="founder-note" className="text-pb-ink text-base sm:text-lg leading-relaxed">
            <span className="font-bold">Built by a mom who's been there too.</span>{" "}
            <span className="text-pb-soft">
              Plate Buddies isn't about clean plates — it's about helping kids explore food without pressure, and helping parents enjoy dinner again.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
